import React from 'react';
import PropTypes from 'prop-types';
import BottomSheet from './bottom-sheet';
import Spacer from '../spacer';
import Button from '../button';
import Input from '../input';
export default function TextInput(props) {
  /*#__PURE__*/
  React.createElement(BottomSheet, null, /*#__PURE__*/React.createElement(Input.TextField, {
    value: props.value,
    label: props.header,
    placeholder: props.placeholder
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), /*#__PURE__*/React.createElement(Button, {
    onPress: props.onPress
  }, props.button));
}
TextInput.defaultProps = {
  header: 'Change Employer Code',
  onPress: () => {},
  button: 'Update',
  value: '',
  placeholder: 'Employer Code'
};
TextInput.propTypes = {
  header: PropTypes.string,
  onPress: PropTypes.func,
  button: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string
};
//# sourceMappingURL=text-input.js.map